import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderSpinnerService } from '../loader-spinner.service';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationCancel } from '@angular/router';
import { LoaderSpinnerState } from '../loader-spinner-state';

@Component({
  selector: 'pv-loader-spinner',
  templateUrl: './loader-spinner.component.html',
  styleUrls: ['./loader-spinner.component.scss']
})
export class LoaderSpinnerComponent implements OnInit, OnDestroy {
  show = false;

  private subscription: Subscription

  constructor(
    private loaderSpinnerService: LoaderSpinnerService,
    private router: Router
  ) { }

  ngOnInit()
  {
    // this.router.events
    //   .subscribe((event) => {
    //     if (event instanceof RouteConfigLoadStart) {
    //       //this.loaderSpinnerService.show()
    //     } else if (
    //       event instanceof RouteConfigLoadEnd ||
    //       event instanceof NavigationCancel
    //     ) {
    //       this.loaderSpinnerService.hide()
    //     }
    //   })



    this.subscription = this.loaderSpinnerService.loaderSpinnerState
      .subscribe((state: LoaderSpinnerState) => {
        this.show = state.show;
      })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
